/**
 * Copyright schukai GmbH and contributors 2023. All Rights Reserved.
 * Node module: @schukai/monster
 * This file is licensed under the AGPLv3 License.
 * License text available at https://www.gnu.org/licenses/agpl-3.0.en.html
 */

import { ATTRIBUTE_PREFIX } from "../../dom/constants.mjs";

/**
 * @memberOf Monster.Components.Form
 * @since 1.0.0
 * @type {string}
 */
const STYLE_DISPLAY_MODE_BLOCK = "block";

/**
 * This attribute `data-monster-url` can be used to pass a URL to the control.
 *
 * @memberOf Monster.Components.Form
 * @since 1.0.0
 * @type {string}
 */
const ATTRIBUTE_FORM_URL = `${ATTRIBUTE_PREFIX}url`;

/**
 * This attribute `data-monster-reload` can be used to control the reload.
 *
 * valid values: onshow
 *
 * @memberOf Monster.Components.Form
 * @since 1.11.0
 * @type {string}
 */
const ATTRIBUTE_FORM_RELOAD = `${ATTRIBUTE_PREFIX}reload`;

/**
 * `data-monster-intend`
 *
 * @memberOf Monster.Components.Form
 * @since 1.9.0
 * @type {string}
 */
const ATTRIBUTE_VISIBILITY = `${ATTRIBUTE_PREFIX}visibility`;
/**
 * `data-monster-intend`
 *
 * @memberOf Monster.Components.Form
 * @since 1.9.0
 * @deprecated since 3.32.0
 * @type {string}
 */
const ATTRIBUTE_BUTTON_CLASS = `${ATTRIBUTE_PREFIX}button-class`;

/**
 * `data-monster-intend`
 *
 * @memberOf Monster.Components.Form
 * @since 1.8.0
 * @type {string}
 */
const ATTRIBUTE_INTEND = `${ATTRIBUTE_PREFIX}intend`;

/**
 * `data-monster-has-children`
 *
 * @memberOf Monster.Components.Form
 * @since 1.8.0
 * @type {string}
 */
const ATTRIBUTE_HAS_CHILDREN = `${ATTRIBUTE_PREFIX}has-children`;

/**
 * This attribute `data-monster-datasource` can be used to pass a datasource.
 *
 * @memberOf Monster.Components.Form
 * @since 1.6.0
 * @type {string}
 */
const ATTRIBUTE_FORM_DATASOURCE = `${ATTRIBUTE_PREFIX}datasource`;

/**
 * This attribute `data-monster-datasource-arguments` can be used to pass arguments.
 *
 * @memberOf Monster.Components.Form
 * @since 1.6.0
 * @type {string}
 */
const ATTRIBUTE_FORM_DATASOURCE_ARGUMENTS = `${ATTRIBUTE_PREFIX}datasource-arguments`;

/**
 * This attribute `data-monster-button-label` can be used to pass labels.
 *
 * @memberOf Monster.Components.Form
 * @since 1.6.0
 * @type {string}
 */
const ATTRIBUTE_BUTTON_LABEL = `${ATTRIBUTE_PREFIX}button-label`;

export {
	ATTRIBUTE_BUTTON_LABEL,
	STYLE_DISPLAY_MODE_BLOCK,
	ATTRIBUTE_FORM_URL,
	ATTRIBUTE_FORM_DATASOURCE,
	ATTRIBUTE_FORM_DATASOURCE_ARGUMENTS,
	ATTRIBUTE_INTEND,
	ATTRIBUTE_VISIBILITY,
	ATTRIBUTE_FORM_RELOAD,
	ATTRIBUTE_HAS_CHILDREN,
	ATTRIBUTE_BUTTON_CLASS,
};
